import React from "react";

interface ChevronLeftIconProps {
  className?: string;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({
  className = "w-4 h-4",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_2604_1216"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect
        x="16"
        y="16"
        width="16"
        height="16"
        transform="rotate(-180 16 16)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_2604_1216)">
      <path
        d="M6.11291 7.99984L11.1347 13.0217C11.2672 13.1541 11.3317 13.3118 11.3282 13.4947C11.3248 13.6776 11.2568 13.8353 11.1244 13.9678C10.992 14.1003 10.8343 14.1665 10.6514 14.1665C10.4685 14.1665 10.3108 14.1003 10.1782 13.9678L5.07441 8.85367C4.95396 8.73312 4.86468 8.59806 4.80657 8.44851C4.74835 8.29895 4.71924 8.14939 4.71924 7.99984C4.71924 7.85028 4.74835 7.70073 4.80657 7.55117C4.86468 7.40162 4.95396 7.26656 5.07441 7.14601L10.1886 2.03184C10.321 1.89939 10.477 1.83489 10.6564 1.83834C10.836 1.84178 10.992 1.90973 11.1244 2.04217C11.2569 2.17462 11.3231 2.33228 11.3231 2.51517C11.3231 2.69806 11.2569 2.85578 11.1244 2.98834L6.11291 7.99984Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default ChevronLeftIcon;
